// extracted by mini-css-extract-plugin
module.exports = {"header":"WorkspacesBox_header__2SA8o","box":"WorkspacesBox_box__3CUal","node":"WorkspacesBox_node__24lWe"};